/* OH MY JELLY — global.js */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  /* ---------- marqueur JS ----------
     Posé le plus tôt possible : le CSS s'en sert pour cacher les pills sur
     tactile avant que l'observer ne les révèle. Sans ce marqueur (JS désactivé,
     erreur de script), les pills restent simplement visibles. */
  document.documentElement.classList.add('js');

  /* ---------- [texte] → police de titre, sur tout le site ---------- */
  function applyBracketHeadingFont(root) {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.nodeValue.includes('[')) return NodeFilter.FILTER_SKIP;
        const tag = node.parentElement ? node.parentElement.tagName : '';
        if (['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT'].includes(tag)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    const nodes = [];
    let n;
    while ((n = walker.nextNode())) nodes.push(n);

    nodes.forEach((textNode) => {
      const text = textNode.nodeValue;
      if (!/\[[^\]]+\]/.test(text)) return;
      const frag = document.createDocumentFragment();
      let lastIndex = 0;
      text.replace(/\[([^\]]+)\]/g, (match, inner, offset) => {
        if (offset > lastIndex) frag.appendChild(document.createTextNode(text.slice(lastIndex, offset)));
        const span = document.createElement('span');
        span.className = 'font-heading-inline';
        span.textContent = inner;
        frag.appendChild(span);
        lastIndex = offset + match.length;
        return match;
      });
      if (lastIndex < text.length) frag.appendChild(document.createTextNode(text.slice(lastIndex)));
      textNode.parentNode.replaceChild(frag, textNode);
    });
  }
  applyBracketHeadingFont(document.body);
  // dans l'éditeur Shopify, les sections sont ré-injectées en AJAX sans recharger
  // toute la page : on réapplique donc la conversion à chaque section rechargée
  document.addEventListener('shopify:section:load', (event) => {
    applyBracketHeadingFont(event.target);
    setupPillReveal(event.target);
  });

  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2).replace('.', ',');
    const format = window.moneyFormat || '{{amount}} €';
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value)
      .replace(/\{\{\s*amount\s*\}\}/, value);
  }

  /* ---------- drawers (menu + panier) ---------- */
  function setupDrawer(drawerId, openSelector) {
    const drawer = document.getElementById(drawerId);
    if (!drawer) return;
    const open = () => {
      drawer.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
      const focusable = $('a, button, input', drawer);
      if (focusable) focusable.focus();
    };
    const close = () => {
      drawer.removeAttribute('open');
      document.body.style.overflow = '';
    };
    $$(openSelector).forEach((btn) =>
      btn.addEventListener('click', (e) => { e.preventDefault(); open(); })
    );
    $$('[data-drawer-close]', drawer).forEach((btn) => btn.addEventListener('click', close));
    drawer.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    drawer._open = open;
    drawer._close = close;
  }
  setupDrawer('MenuDrawer', '[data-menu-open]');
  setupDrawer('CartDrawer', '[data-cart-open]');

  /* ---------- panier AJAX ---------- */
  async function refreshCart() {
    const res = await fetch(window.routes.cart_url + '.js');
    const cart = await res.json();
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.toggleAttribute('hidden', cart.item_count === 0);
    });
    renderCartDrawer(cart);
    return cart;
  }

  function renderCartDrawer(cart) {
    const drawer = $('#CartDrawer');
    const list = $('#CartDrawerItems');
    const foot = $('#CartDrawerFoot');
    if (!drawer || !list) return;

    const countEl = $('[data-drawer-count]', drawer);
    if (countEl) countEl.textContent = `· ${cart.item_count}`;

    const shippingThreshold = parseInt(drawer.dataset.shippingThreshold || '0', 10);
    const shippingCopy = $('[data-shipping-copy]', drawer);
    const shippingFill = $('[data-shipping-fill]', drawer);
    const shippingBox = $('[data-shipping-box]', drawer);
    if (shippingBox) {
      if (shippingThreshold > 0 && cart.item_count > 0) {
        shippingBox.hidden = false;
        const remaining = Math.max(0, shippingThreshold - cart.total_price);
        const progress = Math.min(100, (cart.total_price / shippingThreshold) * 100);
        if (shippingFill) shippingFill.style.width = `${progress}%`;
        if (shippingCopy) {
          const progressText = drawer.dataset.shippingProgressText || 'Plus que [montant] pour la livraison offerte';
          const unlockedText = drawer.dataset.shippingUnlockedText || 'Livraison offerte débloquée ✨';
          shippingCopy.innerHTML = remaining > 0
            ? progressText.replace('[montant]', `<strong>${formatMoney(remaining)}</strong>`)
            : `<strong>${unlockedText}</strong>`;
        }
        shippingBox.classList.toggle('is-complete', remaining === 0);
      } else {
        shippingBox.hidden = true;
      }
    }

    if (cart.item_count === 0) {
      const emptyTitle = list.dataset.emptyTitle || 'Ton panier est vide';
      const emptyText = list.dataset.emptyText || '';
      const emptyButton = list.dataset.emptyButton || 'Découvrir les Jellys';
      const emptyLink = list.dataset.emptyLink || '/collections/all';
      list.innerHTML = `<div class="cart-drawer__empty"><strong>${emptyTitle}</strong><p>${emptyText}</p><a href="${emptyLink}" class="btn btn--solid">${emptyButton}</a></div>`;
      if (foot) foot.hidden = true;
      return;
    }

    if (foot) {
      foot.hidden = false;
      const totalEl = $('[data-cart-total]', foot);
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

      const upsell = $('[data-cart-upsell]', foot);
      if (upsell) {
        const upsellProductId = String(upsell.dataset.productId || '');
        const alreadyInCart = cart.items.some((item) => String(item.product_id) === upsellProductId);
        upsell.hidden = alreadyInCart;
      }
    }

    list.innerHTML = cart.items.map((item) => `
      <div class="cart-drawer__item card">
        <a href="${item.url}" class="cart-drawer__item-media">
          <img src="${item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1$2') : ''}" alt="" width="80" height="96" loading="lazy">
        </a>
        <div class="cart-drawer__item-main">
          <div class="cart-drawer__item-top">
            <a href="${item.url}" class="cart-drawer__item-title">${item.product_title}</a>
            <button type="button" class="cart-drawer__remove" data-line-change="${item.key}" data-qty="0" aria-label="Supprimer ${item.product_title}">×</button>
          </div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-drawer__variant">${item.variant_title}</div>` : ''}
          <div class="cart-drawer__item-bottom">
            <div class="qty-input cart-drawer__qty">
              <button type="button" data-line-change="${item.key}" data-qty="${Math.max(0, item.quantity - 1)}" aria-label="Retirer une unité">−</button>
              <input type="text" value="${item.quantity}" readonly aria-label="Quantité">
              <button type="button" data-line-change="${item.key}" data-qty="${item.quantity + 1}" aria-label="Ajouter une unité">+</button>
            </div>
            <strong class="cart-drawer__item-price">${formatMoney(item.final_line_price)}</strong>
          </div>
        </div>
      </div>`).join('');

    $$('[data-line-change]', list).forEach((btn) =>
      btn.addEventListener('click', async () => {
        btn.disabled = true;
        await fetch(window.routes.cart_change_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: btn.dataset.lineChange, quantity: parseInt(btn.dataset.qty, 10) })
        });
        await refreshCart();
      })
    );
  }

  const cartUpsellButton = $('[data-upsell-add]');
  if (cartUpsellButton) {
    cartUpsellButton.addEventListener('click', async () => {
      const upsell = cartUpsellButton.closest('[data-cart-upsell]');
      if (!upsell) return;
      cartUpsellButton.disabled = true;
      const original = cartUpsellButton.textContent;
      cartUpsellButton.textContent = 'Ajout…';
      try {
        const res = await fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(upsell.dataset.variantId), quantity: 1 }] })
        });
        if (!res.ok) throw new Error();
        await refreshCart();
      } catch (e) {
        cartUpsellButton.disabled = false;
        cartUpsellButton.textContent = original;
      }
    });
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = $('[type="submit"]', form);
    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.dataset.addingText || '...';
    try {
      const res = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        body: new FormData(form)
      });
      if (!res.ok) throw new Error();
      await refreshCart();
      const drawer = document.getElementById('CartDrawer');
      if (drawer && drawer._open) drawer._open();
    } catch (err) {
      window.location.href = window.routes.cart_url;
    } finally {
      btn.disabled = false;
      btn.textContent = original;
    }
  });

  refreshCart();

  /* ---------- rafraîchir le panier depuis une section externe ----------
     Le formulaire produit gère déjà son propre ajout (submit listener
     ci-dessus). Pour toute section qui ajoute au panier autrement (ex: le
     sélecteur de bundle mix & match, qui pousse plusieurs produits d'un coup
     via fetch), on écoute cet événement plutôt que de dupliquer la logique
     de refreshCart + ouverture du drawer. */
  document.addEventListener('cart:updated', async () => {
    await refreshCart();
    const drawer = document.getElementById('CartDrawer');
    if (drawer && drawer._open) drawer._open();
  });

  /* ---------- sélecteur de variantes ---------- */
  $$('[data-variant-json]').forEach((script) => {
    const variants = JSON.parse(script.textContent);
    const wrapper = script.closest('[data-product-wrapper]');
    if (!wrapper) return;
    const idInput = $('[name="id"]', wrapper);
    const priceEl = $('[data-price]', wrapper);
    const btn = $('[data-atc]', wrapper);

    function currentOptions() {
      return $$('.variant-options', wrapper).map(
        (group) => $('input:checked', group)?.value
      );
    }
    function update() {
      const opts = currentOptions();
      const match = variants.find((v) =>
        v.options.every((opt, i) => opt === opts[i])
      );
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (btn) {
        btn.disabled = !match.available;
        let label = match.available ? btn.dataset.addText : btn.dataset.soldoutText;
        // le prix suit la variante : sans ça, il resterait figé sur celui du
        // chargement puisque textContent réécrit tout le contenu du bouton
        if (match.available && btn.dataset.showPrice === 'true') {
          label += ' · ' + formatMoney(match.price);
        }
        btn.textContent = label;
      }
    }
    wrapper.addEventListener('change', (e) => {
      if (e.target.matches('.variant-options input')) update();
    });
    update();
  });

  /* ---------- quantité ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const input = $('input', btn.closest('.qty-input'));
    const next = parseInt(input.value, 10) + parseInt(btn.dataset.qtyChange, 10);
    input.value = Math.max(1, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- sticky offre produit ----------
     Le sticky ne doit apparaître qu'APRÈS que le vrai bouton d'achat a été
     dépassé. L'ancien IntersectionObserver l'affichait aussi avant d'atteindre
     le formulaire, puisqu'un élément hors écran en dessous est lui aussi
     "non intersecting". Ici on teste donc explicitement que le bas du bouton
     est passé au-dessus du viewport.

     Au clic, on ne soumet rien : on remonte vers le dernier bloc d'offre/app
     placé avant le formulaire (Kaching Bundles / Subscriptions), avec fallback
     sur le bundle natif puis le formulaire.
  ---------- */
  const stickyBar = $('.sticky-atc');
  const productForm = $('form[data-product-form]');
  if (stickyBar && productForm) {
    const realAtc = $('[data-atc]', productForm) || productForm;
    const productInfo = productForm.closest('.product-info') || productForm.parentElement;

    const findOfferTarget = () => {
      if (!productInfo) return productForm;

      const candidates = $$('[data-product-offer], .product-bundle, .product-block--app', productInfo)
        .filter((el) => {
          const pos = el.compareDocumentPosition(productForm);
          return Boolean(pos & Node.DOCUMENT_POSITION_FOLLOWING);
        });

      return candidates[candidates.length - 1] || productForm;
    };

    let ticking = false;
    const updateStickyOffer = () => {
      const passedAtc = realAtc.getBoundingClientRect().bottom < 0;
      stickyBar.classList.toggle('is-visible', passedAtc);
      stickyBar.setAttribute('aria-hidden', passedAtc ? 'false' : 'true');
      ticking = false;
    };

    const requestStickyUpdate = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateStickyOffer);
    };

    window.addEventListener('scroll', requestStickyUpdate, { passive: true });
    window.addEventListener('resize', requestStickyUpdate);
    updateStickyOffer();

    $('[data-sticky-atc]', stickyBar)?.addEventListener('click', () => {
      const target = findOfferTarget();
      const headerOffset = 96;
      const top = target.getBoundingClientRect().top + window.scrollY - headerOffset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    });
  }

  /* ---------- rotation des messages de la barre d'annonce ---------- */
  const announcement = $('[data-announcement]');
  if (announcement) {
    const items = $$('.announcement-bar__item', announcement);
    if (items.length > 1) {
      let current = 0;
      const speed = parseInt(announcement.dataset.rotateSpeed, 10) || 4000;
      setInterval(() => {
        items[current].classList.remove('is-active');
        current = (current + 1) % items.length;
        items[current].classList.add('is-active');
      }, speed);
    }
  }

  /* ---------- reveal on scroll ---------- */
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('in-view'); io.unobserve(en.target); }
      }),
      { threshold: 0.12 }
    );
    $$('[data-animate]').forEach((el) => io.observe(el));
  }

  /* ---------- carte active sur tactile ----------
     Le desktop est géré en CSS (:hover) : sur tactile, iOS simule le survol au
     premier tap puis le laisse collé, donc on pilote une classe .is-active.

     Deux déclencheurs, parce qu'un seul ne couvre pas les deux gestes :
       · le doigt qui se pose sur une carte  → tap et appui lent
       · la carte la plus centrée pendant le scroll → swipe

     Deux classes : .is-revealed (définitive, les pills restent) et .is-active
     (transitoire, la seconde photo).

     On n'écoute NI touchend NI touchcancel. Dès que le navigateur requalifie le
     geste en scroll — c'est-à-dire immédiatement sur un vrai swipe — il émet un
     touchcancel et plus jamais de touchend : la carte s'éteindrait aussitôt
     allumée. L'extinction est donc pilotée par l'arrêt du mouvement, ce qui
     couvre aussi l'inertie qui continue après que le doigt est parti. */
  function setupPillReveal(root = document) {
    if (window.matchMedia('(hover: hover)').matches) return;

    // .is-revealed est définitive : une fois les pills d'une carte découvertes,
    // elles restent. .is-active est transitoire et ne pilote que la seconde photo.
    function activate(card) {
      if (!card) return;
      card.classList.add('is-revealed');
      if (card.classList.contains('is-active')) return;
      $$('.product-card.is-active').forEach((other) => {
        if (other !== card) other.classList.remove('is-active');
      });
      card.classList.add('is-active');
    }

    function clearAll() {
      $$('.product-card.is-active').forEach((c) => c.classList.remove('is-active'));
    }

    // la carte que traverse l'axe vertical central du slider
    function centeredCard(slider) {
      const box = slider.getBoundingClientRect();
      const mid = box.left + box.width / 2;
      return $$('.product-card', slider).find((card) => {
        const r = card.getBoundingClientRect();
        return r.left <= mid && r.right >= mid;
      });
    }

    // un seul minuteur partagé : sinon le compte à rebours du tap éteindrait la
    // carte en plein swipe, et celui du scroll la garderait allumée après un tap
    let idle;
    function scheduleClear(delay) {
      clearTimeout(idle);
      idle = setTimeout(clearAll, delay);
    }

    $$('.product-card', root).forEach((card) => {
      card.addEventListener('touchstart', () => {
        clearTimeout(idle);
        activate(card);
      }, { passive: true });
      // tap sans scroll : aucun événement scroll ne viendra rendre la main
      card.addEventListener('touchend', () => scheduleClear(260), { passive: true });
    });

    $$('.card-grid--carousel', root).forEach((slider) => {
      slider.addEventListener('scroll', () => {
        activate(centeredCard(slider));
        // 220ms sans nouvel événement scroll = le mouvement, inertie comprise,
        // est terminé
        scheduleClear(220);
      }, { passive: true });
    });
  }
  setupPillReveal();

  /* ---------- zoom cinématique lié au scroll (parallax doux sur les photos) ---------- */
  const zoomEls = $$('.zoom-media');
  if (zoomEls.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let ticking = false;

    function updateZoom() {
      const vh = window.innerHeight;
      zoomEls.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        const elCenter = rect.top + rect.height / 2;
        const viewCenter = vh / 2;
        const maxDist = vh / 2 + rect.height / 2;
        const progress = 1 - Math.min(Math.abs(elCenter - viewCenter) / maxDist, 1);
        const scale = 1 + (1 - progress) * 0.12;
        const media = $('img, video', el);
        if (media) media.style.setProperty('--zoom-scale', scale.toFixed(4));
      });
      ticking = false;
    }

    function onScroll() {
      if (!ticking) { requestAnimationFrame(updateZoom); ticking = true; }
    }

    updateZoom();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  /* ---------- header transparent overlay (homepage only) ---------- */
  // Le header démarre TOUJOURS en mode normal/solide (sûr, toujours visible).
  // On ne l'active en mode transparent que si on a confirmé côté DOM qu'un
  // hero avec image/vidéo existe, et seulement après avoir calculé sa
  // position exacte — jamais de classe "overlay" posée sans position connue.
  const siteHeader = $('#SiteHeader');
  const heroWithMedia = document.body.classList.contains('template-index') ? $('.hero:not(.hero--text-only)') : null;

  if (siteHeader && heroWithMedia) {
    function heroTop() {
      return heroWithMedia.getBoundingClientRect().top + window.scrollY;
    }

    function placeHeader() {
      const scrolled = window.scrollY > 4;
      siteHeader.classList.toggle('is-fixed', scrolled);
      siteHeader.classList.toggle('is-solid', scrolled);
      siteHeader.style.top = scrolled ? '0px' : heroTop() + 'px';
    }

    siteHeader.classList.add('site-header--overlay');
    placeHeader();
    window.addEventListener('scroll', placeHeader, { passive: true });
    window.addEventListener('resize', placeHeader);
    window.addEventListener('load', placeHeader);
  }
})();